import { Button } from "react-bootstrap";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import PrintLabelButton from "../../../../components/Shipment/Label/PrintLabelButton";
import DigikalaShippingProviderEnum from "../DigikalaShippingProviderEnum";
import OrderChangeToProcessingButton from "./OrderChangeToProcessingButton";

export default function OrdersTable({
  items,
  onOpenDetails,
  refetch,
  filters,
}) {
  return (
    <div className="w-100 px-1 overflow-x-auto">
      <table
        className="table table-striped table-bordered"
        style={{ minWidth: 1800 }}
      >
        <thead>
          <tr className="align-middle">
            <th className="text-center">ردیف</th>
            <th className="text-center">شماره سفارش</th>
            <th className="text-center" style={{ minWidth: 400 }}>
              عنوان کالاها
            </th>
            <th className="text-center">شماره مرسوله و ماهیت</th>
            <th className="text-center" style={{ minWidth: 140 }}>
              تاریخ سفارش
            </th>
            <th className="text-center" style={{ minWidth: 180 }}>
              تعهد تحویل به سرویس
            </th>
            <th className="text-center" style={{ minWidth: 140 }}>
              تعهد ارسال به خریدار
            </th>
            <th className="text-center" style={{ minWidth: 140 }}>
              مقصد ارسال مرسوله
            </th>
            <th className="text-center">شیوه ارسال</th>
            <th className="text-center">تعداد کالای مرسوله</th>
            <th className="text-center">هزینه ارسال (ریال)</th>
            <th className="text-center">وضعیت مرسوله</th>
            <th className="text-center">عملیات</th>
          </tr>
        </thead>

        <tbody>
          {items.map((row, idx) => (
            <tr key={row.orderId || `${idx}`} className="align-middle">
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {idx + 1 + (filters.get("page") - 1) * filters.get("items")}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {row?.orderId}
              </td>

              <td>
                {row?.variants?.map((product, idx) => (
                  <div
                    key={idx}
                    className="w-100 d-flex align-items-center column-gap-2 p-1"
                  >
                    <div>
                      <img
                        src={product.image_url}
                        alt="تصویر کالا"
                        style={{
                          width: 50,
                          height: 50,
                          objectFit: "contain",
                          borderRadius: "8px",
                        }}
                      />
                    </div>

                    <div>
                      <p className="mb-0">{product.title}</p>

                      <div className="d-flex flex-wrap pb-2">
                        <p className="mb-0">
                          <span>تعداد: </span>
                          <span>{product.count}</span>
                        </p>

                        <p className="mb-0 me-3">
                          <span>قیمت پایه: </span>
                          <span>{product?.price?.toLocaleString()}</span>
                        </p>
                      </div>

                      <p className="d-inline-flex align-items-center column-gap-2 px-2 mb-0 mx-auto text-center border rounded-2 border-black">
                        <span>قیمت کل: </span>
                        <strong style={{ fontSize: 18 }}>
                          {product?.total_price?.toLocaleString()}
                        </strong>
                        <span style={{ fontSize: 12 }}> ریال</span>
                      </p>
                    </div>
                  </div>
                ))}
              </td>

              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                <div className="text-center">{row?.shipmentId}</div>
                <span
                  className="badge alert alert-secondary py-2"
                  style={{
                    borderRadius: 150,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  {row?.shippingNature?.text || ""}
                </span>
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {row?.orderDate}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {row?.postPromiseDate}
              </td>

              <td className="text-center">-</td>

              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {[
                  row?.address?.state,
                  row?.address?.city,
                  row?.address?.district,
                ]
                  .filter(Boolean)
                  .join(" - ")}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {DigikalaShippingProviderEnum[row?.shippingProvider] || ""}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {row?.itemCount}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                {Number(row?.shippingCost || 0)?.toLocaleString()}
              </td>
              <td
                style={{ borderRight: "1px solid #dee2e6" }}
                className="text-center"
              >
                <span
                  className="badge alert alert-info py-2"
                  style={{
                    borderRadius: 150,
                    paddingLeft: 10,
                    paddingRight: 10,
                  }}
                >
                  {row?.status?.text_fa || ""}
                </span>
              </td>

              <td>
                <div className="d-flex justify-content-center align-items-center">
                  {row.status?.text === "pending" && (
                    <OrderChangeToProcessingButton
                      refetch={refetch}
                      row={row}
                    />
                  )}

                  {row.status?.text === "processing" && (
                    <Button
                      variant="primary"
                      type="button"
                      className="btn btn-success-style"
                      onClick={() => onOpenDetails(row)}
                    >
                      مشاهده و ثبت بارکد
                    </Button>
                  )}

                  {["processed", "sent_to_post"].includes(row.status?.text) &&
                    !!row?.numberParcel && (
                      <div className="d-flex flex-column justify-content-center align-items-center px-1">
                        <PrintLink
                          ids={[row?.numberParcel]}
                          byNumberParcel
                          className="btn text-center text-white fw-bold btn-success-style btn-cancel-style m-1"
                        >
                          پرینت فاکتور
                        </PrintLink>

                        <PrintLabelButton
                          numberParcels={[row?.numberParcel]}
                          className="btn text-center text-white fw-bold btn-success-style btn-cancel-style m-1"
                        >
                          پرینت لیبل
                        </PrintLabelButton>
                      </div>
                    )}

                  {["processed", "sent_to_post"].includes(row.status?.text) &&
                    !row?.numberParcel && (
                      <div className="alert alert-info">
                        این سفارش توسط آواکس ثبت نشده است
                      </div>
                    )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
